module.exports = require("core-js-pure/stable/object/keys");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js-stable/object/keys.js
// module id = 2855
// module chunks = 25